import { createContext, useContext, type ReactNode } from 'react'

export interface FormThemeColors {
  text: string
  textSecondary: string
  textMuted: string
  textDimmed: string
  bgInput: string
  bgCard: string
  bgCardSolid: string
  bgHover: string
  border: string
  accent: string
  accentGradient: string
  error: string
  success: string
  isDark: boolean
}

// Values mirror m3 tokens from apps/web/src/theme/index.ts
const defaultColors: FormThemeColors = {
  text: '#2a2622',              // m3.onSurface
  textSecondary: '#414844',     // m3.onSurfaceVariant
  textMuted: '#414844',         // m3.onSurfaceVariant
  textDimmed: '#857b71',        // m3.outline
  bgInput: '#ebefed',           // m3.surfaceContainer
  bgCard: '#ffffff',            // m3.surfaceContainerLowest
  bgCardSolid: '#ffffff',       // m3.surfaceContainerLowest
  bgHover: '#e6e9e7',          // m3.surfaceContainerHigh
  border: '#c1c8c2',           // m3.outlineVariant
  accent: '#012d1d',            // m3.primary
  accentGradient: '#012d1d',    // m3.primary
  error: '#b23a26',             // m3.error
  success: '#2a8a87',           // m3.success
  isDark: false,
}

const FormThemeContext = createContext<FormThemeColors>(defaultColors)

export function FormThemeProvider({
  colors,
  children,
}: {
  colors: FormThemeColors
  children: ReactNode
}) {
  return (
    <FormThemeContext.Provider value={colors}>
      {children}
    </FormThemeContext.Provider>
  )
}

export function useFormColors() {
  return useContext(FormThemeContext)
}
